import React, { Component } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { connect } from 'react-redux';

class Spinner extends Component {
  render() {

    return (
      <div class="wts-loader-container">
        <div class="wts-loader"></div>
      </div>
    )
  }
}

export {Spinner}


// WEBPACK FOOTER //
// ./src/Spinner/Spinner.jsx